import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import compStage from "./components/compStage.vue";
import goodsOptions from "../../components/serverList/goodsOptions.vue";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
import { getGameServerMap, getReasonMap, getGameGoodsMap, getGameGoodsQualityMap } from "@/utils/dictionary";
export default {
  components: {
    serverList: serverList,
    compStage: compStage,
    goodsOptions: goodsOptions,
    timeDateOptions: timeDateOptions
  },
  name: "itemLog",
  data: function data() {
    return {
      goodsList: {},
      goodsQualityList: {},
      goodsArray: [],
      serverList: {},
      reasonList: {},
      reasonArray: [],
      typeArray: [],
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      searchInfo: {
        goods_id: ""
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var index, _index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameGoodsMap();
            case 2:
              _this.goodsList = _context.sent;
              _context.next = 5;
              return getGameGoodsQualityMap();
            case 5:
              _this.goodsQualityList = _context.sent;
              for (index in _this.goodsList) {
                _this.goodsArray.push({
                  goodsId: index,
                  goodsName: _this.goodsList[index]
                });
              }
              _context.next = 9;
              return getGameServerMap();
            case 9:
              _this.serverList = _context.sent;
              _context.next = 12;
              return getReasonMap();
            case 12:
              _this.reasonList = _context.sent;
              for (_index in _this.reasonList) {
                _this.reasonArray.push({
                  id: _index,
                  name: _this.reasonList[_index]
                });
              }
              _this.typeArray = [{
                id: 1,
                name: '获得'
              }, {
                id: -1,
                name: '消耗'
              }];
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent(e) {
      this.searchInfo.sdate = this.timedata[0];
      this.searchInfo.edate = this.timedata[1];
      if (e == "search") {
        this.$refs.myChild.goMethod("1", this.searchInfo);
      } else {
        this.$refs.myChild.goMethod("2", this.searchInfo);
      }
    }
  }
};